<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :tabs="tabs"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :formsConfig="formsConfig"
    :key="pageKey"
    :hot-key-grid-tab-index="5"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Product"
        :baseView="baseView"
        :createModeIsEditMode="true"
        :primaryLabel="model.ProductCode"
        :secondaryLabel="model.ProductDescription1"
        recordType="Product"
        v-if="model.ProductCode"
      />
    </template>
    <div class="css-v2 split-view">
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <div class="css-v2 split-view-list">
            <gc-filter-split-view
              :showLeftContainer="showFilterLeftContainer"
              :showRightContainer="showFilterRightContainer"
            >
              <template #leftContent>
                <dx-data-grid
                  :data-source="dataSourceConfig"
                  ref="productDimensionGrid"
                  :columns="columns"
                  :height="gridHeight - 20"
                  @selection-changed="onSelectionChanged"
                  @content-ready="addGridNoResults($event)"
                  v-if="model.ProductCode"
                  :selection="{ mode: 'single' }"
                  @toolbar-preparing="onToolbarPreparing($event)"
                  @exporting="
                    onGridToExcelExporting(
                      $event,
                      `Product - ${baseView.id} - Dimensions`,
                      columns
                    )
                  "
                >
                  <DxPaging :page-size="50" :enabled="false" />
                  <DxPager
                    :showInfo="true"
                    :showPageSizeSelector="false"
                    :infoText="'({2} items)'"
                    :visible="false"
                  />

                  <DxScrolling
                    :mode="'virtual'"
                    :row-rendering-mode="'virtual'"
                    :preloadEnabled="true"
                  />
                  <DxExport :enabled="true" />
                  <template #default-cell-template="{ data }">
                    <DxCheckBox
                      :value="data.data.IsStockUM == 'Y'"
                      :read-only="true"
                    />
                  </template>
                </dx-data-grid>
              </template>
              <template #rightContent>
                <gc-advance-filter-panel
                  :toolbar="filterToolbar"
                  :setFilterFormHeight="filterFormHeight"
                  :sideBarTabs="sideBarTabs"
                  :filterFormItems="filterFormItems"
                  :filterModel="getAdvanceFilterModel"
                  :isJson="false"
                  :screenType="'supplier-contact-list'"
                  :data-source-config="dataSourceConfig"
                  :initial-filter="initialFilter"
                  v-if="model.ProductCode"
                >
                </gc-advance-filter-panel>
              </template>
            </gc-filter-split-view>
          </div>
        </template>

        <template #rightContent>
          <DxToolbar class="split-view-toolbar">
            <DxItem #default location="before" locate-in-menu="never">
              <div class="toolbar-label">
                <span class="text-primary">{{ model.UnitOfMeasureCode }}</span>
              </div>
            </DxItem>
            <DxItem
              :options="toolbar.audit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
            />

            <DxItem
              :options="toolbar.edit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              :visible="formsConfig.editableOption"
              v-if="baseView.mode == 'review'"
            />

            <DxItem
              :options="toolbar.save"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode != 'review'"
            />

            <DxItem
              :options="toolbar.close"
              location="after"
              widget="dxButton"
            />
          </DxToolbar>
          <div class="view-card responsive-paddings">
            <form>
              <DxForm
                :form-data.sync="model"
                :read-only="false"
                :show-colon-after-label="false"
                :show-required-mark="false"
                :show-validation-summary="false"
                :validation-group="formsConfig.validationGroup"
                :col-count-by-screen="formsConfig.splitViewColCountByScreen"
                label-location="left"
                :customizeItem="customizeItem"
                :items="items"
              ></DxForm>
            </form>
          </div>
        </template>
      </gc-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import { ProductService } from "../../_services/api/products/product.service";
import { ProductDimensionService } from "../../_services/api/products/product-dimension.service";
import {
  ProductTabs,
  ProductTabsVisibility,
} from "../../_models/tabdata/products/products-tabs";

export default {
  mixins: [BaseViewMixin],
  created() {
    this.selectedIndex = 5;
  },
  data() {
    return {
      toolbar: {
        close: {
          icon: "close",
          onClick: this.close,
        },
        edit: {
          icon: "edit",

          onClick: () => {
            this.$router.push({
              path: `/product-dimension/edit/${this.baseView.id}`,
            });
          },
        },
        save: {
          icon: "floppy",
          validationGroup: "formsData",
          onClick: (e) => {
            this.$logger.trackEventButtonClickSave();
            this.saveProductDimension(e);
          },
        },

        audit: {
          icon: "clock",

          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged
            );
          },
        },
      },
      advanceFilterModel: {
        UnitOfMeasureCode: "",
      },
      model: {
        ProductCode: "",
        ProductDescription1: "",
        BranchCode: "",
        BinLocationCode: "",
        IsStockUM: true,
        RecordId: "00000000-0000-0000-0000-000000000000",
        UnitOfMeasureCode: "",
        Height: 0,
        Weight: 0,
        Length: 0,
        Width: 0,
        CubicMetres: 0,
        DateChanged: "",
        DateCreated: "",
        ChangedBy: "",
        CreatedBy: "",
      },
    };
  },
  computed: {
    items() {
      let formFields = [
        {
          itemType: "group",
          caption: "",
          items: this.parseFormColumns([
            {
              dataField: "Weight",
              gcType: "Decimal-4-4",
              gcLabel: "Weight (kg)",
              validationRules: [
                {
                  type: "required",
                  message: "Weight is required",
                },
                {
                  type: "range",
                  message: "Weight is not between 0.00 and 9,999.99",
                  min: 0.0,
                  max: 9999.99,
                },
              ],
            },
            {
              dataField: "Width",
              gcType: "Decimal-4-2",
              gcLabel: "Width (cm)",
              editorOptions: {
                onChange: this.onChanged,
              },
              validationRules: [
                {
                  type: "required",
                  message: "Width is required",
                },
                {
                  type: "range",
                  message: "Width is not between 0.00 and 9,999.99",
                  min: 0.0,
                  max: 9999.99,
                },
              ],
            },
            {
              dataField: "Height",
              gcType: "Decimal-4-2",
              gcLabel: "Height (cm)",
              editorOptions: {
                onChange: this.onChanged,
              },
              validationRules: [
                {
                  type: "required",
                  message: "Height is required",
                },
                {
                  type: "range",
                  message: "Height is not between 0.00 and 9,999.99",
                  min: 0.0,
                  max: 9999.99,
                },
              ],
            },
            {
              dataField: "Length",
              gcType: "Decimal-4-2",
              gcLabel: "Length (cm)",
              editorOptions: {
                onChange: this.onChanged,
              },
              validationRules: [
                {
                  type: "required",
                  message: "Length is required",
                },
                {
                  type: "range",
                  message: "Length is not between 0.00 and 9,999.99",
                  min: 0.0,
                  max: 9999.99,
                },
              ],
            },
            {
              dataField: "CubicMetres",
              gcType: "Decimal-4-4",
              gcLabel: "Cubic (m³)",
              disabled: true,
              readOnly: true,
            },

            // {
            //   dataField: "IsStockUM",
            //   disabled: true,
            //   gcLabel: "Stock UM",
            //   gcType: "Boolean",
            // },
          ]),
        },
      ];

      return formFields;
    },
    initialFilter() {
      return [["ProductCode", "=", this.model.ProductCode]];
    },
    getAdvanceFilterModel() {
      return this.advanceFilterModel;
    },
    filterFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: this.parseFormColumns([
            {
              dataField: "UnitOfMeasureCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "UM",
              editorOptions: {
                dataSource: ProductService.dataSourceConfig(
                  "api/UnitOfMeasure",
                  {
                    filter: [["Inactive", "=", false]],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "item-template",
              },
            },
          ]),
        },
      ];
    },
    columns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "UM",
          dataField: "UnitOfMeasureCode",
          gcType: "String",
          gcSubType: "PrimaryRecord",
        },
        {
          gcLabel: "Stock UM",
          dataField: "IsStockUM",
          gcType: "String",
          width: 100,
          cellTemplate: "default-cell-template",
        },
        {
          gcLabel: "Weight (kg)",
          dataField: "Weight",
          gcType: "Decimal-4-2",
        },
        {
          gcLabel: "Width (cm)",
          dataField: "Width",
          gcType: "Decimal-4-2",
        },
        {
          gcLabel: "Height (cm)",
          dataField: "Height",
          gcType: "Decimal-4-2",
        },
        {
          gcLabel: "Length (cm)",
          dataField: "Length",
          gcType: "Decimal-4-2",
        },
        {
          gcLabel: "Cubic (m³)",
          dataField: "CubicMetres",
          gcType: "Decimal-4-4",
        },
      ]);
    },
    dataSourceConfig() {
      // eslint-disable-next-line no-debugger

      return ProductDimensionService.dataSourceConfig(
        "api/ProductDimensionList",
        {
          select: [
            "UnitOfMeasureCode,IsStockUM,Weight,Width,Height,Length,CubicMetres,ProductCode,RecordId",
          ],
          // sort: [{ selector: "ProductCode", desc: false }],
          filter: [["ProductCode", "=", this.model.ProductCode]],
        }
      );
    },
    tabs() {
      if (this.loadingCompleted)
        return ProductTabs(
          this.model.ProductCode
            ? this.model.ProductCode
            : this.baseView.idthis.baseView.id
        );
      else return [];
    },
    showLeftContainer() {
      return !(this.isXSmall && this.baseView.mode !== "");
    },
    showRightContainer() {
      if (
        (this.baseView.mode == "review" || this.baseView.mode == "edit") &&
        this.baseView.id.length < 36
      ) {
        return false;
      }

      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleLocalRouteChange",
    },
    showRightContainer() {
      setTimeout(() => {
        let grid = this.$refs["productDimensionGrid"].instance;
        grid.updateDimensions();
      }, 10);
    },
  },
  methods: {
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      var exportButton = toolbarItems.find((item) => {
        return item.name === "exportButton";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "exportButton" &&
          item.name !== "searchPanel" &&
          item.name !== "columnChooserButton"
        );
      });

      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });

      searchPanel.location = "after";
      exportButton.location = "after";

      e.toolbarOptions.items.unshift(
        searchPanel,
        exportButton,
        columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.showFilterRightContainer = !this.showFilterRightContainer;
              var item = document.getElementById("filter-btn");
              this.$logger.debug("item ", item);
              item.classList.add("dx-state-invisible");
            },
          },
        }
      );
    },
    onChanged() {
      this.model.CubicMetres =
        (this.model.Height / 100) *
        (this.model.Width / 100) *
        (this.model.Length / 100);
    },
    async close() {
      if (this.baseView.mode == "edit") {
        let confirmLeaving = await this.$confirm(
          "You have unsaved changes. Are you sure you want to leave?",
          "Unsaved changes"
        );

        if (confirmLeaving) {
          let grid = this.$refs["productDimensionGrid"].instance;
          grid.clearSelection();

          this.baseView.id = this.model.ProductCode;
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/product-dimension/review/${this.baseView.id}`,
          });
        } else {
          this.next(false);
        }
      } else {
        let grid = this.$refs["productDimensionGrid"].instance;
        grid.clearSelection();

        this.baseView.id = this.model.ProductCode;
        this.setIgnoreRouteChangeConfirmation();
        this.$router.push({
          path: `/product-dimension/review/${this.baseView.id}`,
        });
      }
    },
    backButtonFunction() {
      this.$logger.debug(`Form dirty:  ${this.dirty}`);
      if (this.isDirty == false) {
        this.setIgnoreRouteChangeConfirmation();
      }
      this.$router.push({
        path: "/product",
      });
    },

    async handleLocalRouteChange() {
      let that = this;
      if (
        (this.baseView.mode === "review" || this.baseView.mode === "edit") &&
        this.baseView.id.length == 36
      ) {
        this.model.RecordId = this.baseView.id;
        this.getRecord().then((response) => {
          if (response.data.value.length > 0) {
            that.model.DateChanged = response.data.value[0].DateChanged;
            that.model.DateCreated = response.data.value[0].DateCreated;
            that.model.ChangedBy = response.data.value[0].ChangedBy;
            that.model.CreatedBy = response.data.value[0].CreatedBy;
            that.model.RecordId = response.data.value[0].RecordId;

            that.model.ProductCode = response.data.value[0].Product.Code;
            that.model.ProductDescription1 =
              response.data.value[0].Product.Description1;
            that.model.UnitOfMeasureCode =
              response.data.value[0].UnitOfMeasureCode;
            that.model.Height = response.data.value[0].Height;
            that.model.Weight = response.data.value[0].Weight;
            that.model.Length = response.data.value[0].Length;
            that.model.Width = response.data.value[0].Width;
            that.model.IsStockUM =
              response.data.value[0].UnitOfMeasureCode ==
              response.data.value[0].Product.UnitOfMeasureCode
                ? true
                : false;

            ProductTabsVisibility({
              text: "Kit Components",
              value: response.data.value[0].Product.IsKit == "Y" ? true : false,
            });
            that.onChanged();
            // that.refreshView();
          }
          this.loadingCompleted = true;
        });
      } else {
        if (!that.model.ProductCode) {
          await ProductService.getByCode(that.baseView.id).then((response2) => {
            if (response2.data.value.length > 0) {
              that.model.ProductCode = response2.data.value[0].Code;
              that.model.ProductDescription1 =
                response2.data.value[0].Description1;
              that.model.UnitOfMeasureCode =
                response2.data.value[0].UnitOfMeasureCode;
              // that.refreshView();
              ProductTabsVisibility({
                text: "Kit Components",
                value: response2.data.value[0].IsKit == "Y" ? true : false,
              });
            }
            this.loadingCompleted = true;
          });
        } else {
          // if (this.showRightContainer)
          this.loadingCompleted = true;
        }
      }
    },

    async getRecord() {
      return ProductDimensionService.getByRecordId(this.baseView.id);
    },
    onSelectionChanged({ selectedRowsData }) {
      if (selectedRowsData.length == 0) {
        return;
      }

      this.baseView.id = selectedRowsData[0].RecordId;
      this.$router.push({
        path: `/product-dimension/review/${selectedRowsData[0].RecordId}`,
      });
    },

    async saveProductDimension(e) {
      const result = await e.validationGroup.validate();
      // eslint-disable-next-line no-console
      // this.$logger.debug("Model", this.model);
      if (!result.isValid) {
        this.displayValidationSummary();
        return;
      }
      this.showLoading(true);
      await ProductDimensionService.save(this.baseView.mode, {
        ProductCode: this.model.ProductCode,
        Height: this.model.Height,
        Weight: this.model.Weight,
        Length: this.model.Length,
        Width: this.model.Width,
        RecordId: this.model.RecordId,
      })
        // eslint-disable-next-line no-unused-vars
        .then((res) => {
          // if (this.baseView.mode == "edit") {
          //   this.model.RecordId = res.data.RecordId;
          // }

          this.showLoading(false);
          // eslint-disable-next-line no-console
          // this.$logger.debug("saveProductDimension", res);
          this.$notify(
            `Product Dimension ${this.model.RecordId} saved successfully`,
            "success"
          );
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/product-dimension/review/${this.model.RecordId}`,
          });
        })
        .catch((error) => {
          this.displayServerError(error, "Product dimension save failed");
        });
    },
  },
};
</script>
